import { render, staticRenderFns } from "./CheckoutFinishedPage.vue?vue&type=template&id=4d452c04&scoped=true"
import script from "./CheckoutFinishedPage.vue?vue&type=script&lang=js"
export * from "./CheckoutFinishedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d452c04",
  null
  
)

export default component.exports